import { Button, Snackbar } from "@mui/material";
import { useRegisterSW } from "virtual:pwa-register/react";
import { useCallback } from "react";

export default function ServiceWorkerUpdateDialog() {
    const {
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW();

    const handleUpdate = useCallback(() => {
        updateServiceWorker(true);
    }, [updateServiceWorker]);

    const handleClose = useCallback(() => {
        setNeedRefresh(false);
    }, [setNeedRefresh]);

    return (
        <Snackbar
            open={needRefresh}
            onClose={handleClose}
            autoHideDuration={10000}
            message={
                <span id="service-worker-update-message">
                    Eine neue Version ist verfügbar
                </span>
            }
            ContentProps={{
                "aria-describedby": "service-worker-update-message",
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            action={
                <>
                    <Button color="secondary" size="small" onClick={handleUpdate}>
                        Neu laden
                    </Button>
                    <Button color="inherit" size="small" onClick={handleClose}>
                        Schließen
                    </Button>
                </>
            }
        />
    );
}
